// Convert blueprint JSON to Markdown string

export const blueprintToMarkdown = (blueprint, idea) => {
    if (!blueprint) return '';

    const lines = [];
    
    // Header
    lines.push(`# ${blueprint.app_name}`);
    lines.push('');
    lines.push(`> Generated by Vibe Coding Coach`);
    lines.push('');
    lines.push(`**Original Idea:** ${idea}`);
    lines.push('');
    lines.push(`## Summary`);
    lines.push(blueprint.summary);
    lines.push('');

    // Features
    lines.push(`## Features`);
    lines.push('');
    blueprint.features.forEach((feature, i) => {
        const priorityEmoji = feature.priority === 'core' ? '[CORE]' : 
                              feature.priority === 'nice-to-have' ? '[NICE]' : '[FUTURE]';
        lines.push(`### ${i + 1}. ${feature.name} ${priorityEmoji}`);
        lines.push(feature.description);
        lines.push('');
    });

    // Screens
    lines.push(`## Screens / Pages`);
    lines.push('');
    blueprint.screens.forEach((screen, i) => {
        lines.push(`### ${i + 1}. ${screen.name}`);
        lines.push(`**Purpose:** ${screen.purpose}`);
        lines.push('');
        lines.push('**Components:**');
        screen.components.forEach(comp => {
            lines.push(`- ${comp}`);
        });
        lines.push('');
    });

    // Database
    lines.push(`## Database Structure`);
    lines.push('');
    blueprint.database.forEach(table => {
        lines.push(`### ${table.name}`);
        lines.push('');
        lines.push('| Field |');
        lines.push('|-------|');
        table.fields.forEach(field => {
            lines.push(`| ${field} |`);
        });
        if (table.relationships) {
            lines.push('');
            lines.push(`*Relationships:* ${table.relationships}`);
        }
        lines.push('');
    });

    // API Endpoints
    lines.push(`## API Endpoints`);
    lines.push('');
    lines.push('| Method | Path | Description |');
    lines.push('|--------|------|-------------|');
    blueprint.api_endpoints.forEach(endpoint => {
        lines.push(`| ${endpoint.method} | \`${endpoint.path}\` | ${endpoint.description} |`);
    });
    lines.push('');

    // Build Order
    lines.push(`## Build Order`);
    lines.push('');
    blueprint.build_order.forEach(step => {
        lines.push(`### Phase ${step.order}: ${step.phase}`);
        lines.push('');
        step.tasks.forEach(task => {
            lines.push(`- [ ] ${task}`);
        });
        lines.push('');
    });

    // Checklist
    lines.push(`## Development Checklist`);
    lines.push('');
    const categories = [...new Set(blueprint.checklist.map(item => item.category))];
    categories.forEach(category => {
        lines.push(`### ${category.charAt(0).toUpperCase() + category.slice(1)}`);
        lines.push('');
        blueprint.checklist
            .filter(item => item.category === category)
            .forEach(item => {
                const checkbox = item.completed ? '[x]' : '[ ]';
                lines.push(`- ${checkbox} ${item.task}`);
            });
        lines.push('');
    });

    // Footer
    lines.push('---');
    lines.push(`*Blueprint generated on ${new Date().toLocaleDateString()}*`);

    return lines.join('\n');
};

export const downloadMarkdown = (content, filename) => {
    const blob = new Blob([content], { type: 'text/markdown;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const copyToClipboard = async (text) => {
    // Try modern clipboard API first
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch (err) {
            console.warn('Clipboard API failed, trying fallback:', err);
        }
    }
    
    // Fallback: Use textarea + execCommand for older browsers or restricted contexts
    try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        const successful = document.execCommand('copy');
        document.body.removeChild(textArea);
        
        if (successful) {
            return true;
        }
    } catch (err) {
        console.error('Fallback copy failed:', err);
    }
    
    return false;
};
